module.exports = __webpack_public_path__ + "img/keytana_no.ed50637a.png";